import { CustomProfilesPage } from "./CustomProfilePage";
export default CustomProfilesPage;
